/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./IconArrowLeft.vue?vue&type=template&id=506f64de&scoped=true"
import script from "./IconArrowLeft.vue?vue&type=script&lang=js"
export * from "./IconArrowLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506f64de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('506f64de')) {
      api.createRecord('506f64de', component.options)
    } else {
      api.reload('506f64de', component.options)
    }
    module.hot.accept("./IconArrowLeft.vue?vue&type=template&id=506f64de&scoped=true", function () {
      api.rerender('506f64de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/IconArrowLeft.vue"
export default component.exports